export default

{
    version: '1.3.5',
    welcomeScreen: {
        welcome: 'ようこそ、',
        reload: 'リロード',
        clickReload: 'アカウントにゲームを追加したばかりの場合は、[リロード]をクリックしてください。',
        findMore: 'アカウント設定で追跡するゲームをさらに見つける',
        songList: '曲リスト',
        courses: 'コース',
        songs: '曲',
        system: 'システム',
        arcade: 'アーケード',
        singles: 'シングル',
        doubles: 'ダブル',
        singleCourses: 'シングルコース',
        doubleCourses: 'ダブルコース',
        tips: 'ヒントを見る',
        selectGames: 'ゲームを選択',
        highScoreRankings: 'ハイスコアランキング',
        highScore: 'ハイスコア',
        leaderboard: 'リーダーボード',
        seeInfo: '情報を見る',
        hideInfo: '情報を隠す',
        addArcade: 'アーケード追加',
        trackedGames: '追跡中のゲーム',
        games: 'ゲーム',
        players: 'プレイヤー',
    },
    menu: {
        app: 'アプリ',
        overview: '概要',
        settings: '設定',
        logout: 'ログアウト',
        aboutAndInfo: '情報',
        admin: '管理者',
        back: '戻る',
        arcadeRanking: 'アーケードランキング',
        games: 'ゲーム',
        arcadesSelect: 'アーケード',
        login: 'ログイン',
        songLeaderboard: '曲リーダーボード',
        profile: 'プロフィール',
    },
    listScreen: {
        search: '検索',
        filters: 'フィルター',
        filter: 'フィルター',
        target: '目標',
        nameArtist: '曲名 / アーティスト',
        level: 'レベル',
        filterOn: 'オン',
        songName: '曲名',
        favorite: 'お気に入り',
        artistAlias: 'アーティスト / 別名',
        favoriteShort: 'Fav',
        targetShort: '目標',
        searchName: '名前で検索',
        fullComboCap: 'フルコンボ',
        name: '名前',
        artist: 'アーティスト',
        genre: 'ジャンル',
        easy: 'Easy',
        normal: 'Normal',
        hard: 'Hard',
        another: 'Another',
        title: 'タイトル',
        easyLevel: 'Easyレベル',
        normalLevel: 'Normalレベル',
        hardLevel: 'Hardレベル',
        anotherLevel: 'Anotherレベル',
        easyDoubleLevel: 'E Doubleレベル',
        normalDoubleLevel: 'N Doubleレベル',
        hardDoubleLevel: 'H Doubleレベル',
        anotherDoubleLevel: 'A Doubleレベル',
        noSongs: '曲が見つかりません',
    },
    filter: {
        songFilters: '曲フィルター',
        none: 'なし',
        failed: '失敗',
        clear: 'クリア',
        cleared: 'クリア',
        fullCombo: 'フルコンボ',
        single: 'シングル',
        double: 'ダブル',
        singles: 'シングル',
        doubles: 'ダブル',
        favorite: 'お気に入り',
        target: '目標',
        playStyle: 'プレイスタイル',
        otherFilters: 'その他のフィルター',
        applyFilters: 'フィルターを適用',
        filterOnClear: 'クリア時にフィルターを適用',
        level: 'レベル',
        fullComboShort: 'FC',
        setTarget: '目標を設定',
        setFavorite: 'お気に入りを設定',
        save: '保存',
        grade: 'グレード',
        score: 'スコア',
        update: '更新',
        show: '表示',
        filerOn: 'フィルター',
        onlySinglePlayer: 'シングルプレイのみで利用可能',
        onlySinglePlayerInfo: 'マルチプレイでプレイする場合、コースはバトルモードでプレイできません。 タイトルは黄色くなり、コースが選択されるとカップルモードに切り替わります。',
        trackAll: 'すべてのゲームを追跡',
        removeFilters: 'フィルターを削除',
    },
    login: {
        profileQr: 'プロフィールQR',
        viewProfile: '見る',
        copyCode: 'コードをコピー',
        copied: 'コピーしました',
        languageIs: '日本語',
        english: '英語',
        japanese: '日本語',
        close: '閉じる',
        login: 'ログイン',
        selectLanguage: '言語を選択',
        rankingUrl: 'ランキングURL',
        aboutApp: 'アプリについて',
        register: '登録',
        password: 'パスワード',
        version: 'バージョン',
        email: 'メールアドレス',
        progressTracker: 'レトロ音楽ゲームの進行状況トラッカー',
        emailIsSave: 'メールアドレスは他の人と共有されません。',
        nameInProfile: 'プロフィールに表示されます。',
        gametagName: 'ゲームタグ / 名前',
        profileUrl: 'プロフィールURL',
        formInvalid: 'フォームが無効です',
        confirmPassword: 'パスワードを認証する',
        goLogin: 'ログインする',
        passwordReset: 'パスワードをリセット',
        emailWillBeSendToReset: 'パスワードをリセットするためのメールが送信されます。',
        sendReset: 'リセットを送信',
    },
    settings: {
        settings: 'アカウント設定',
        singlePLay: 'シングルプレイ',
        doublePlay: 'ダブルプレイ',
        accountDetails: 'アカウント詳細',
        gameSelect: 'ゲームを選択',
        gameSelectInfo: '追跡するゲームを選択します。',
        accountInfo: 'アカウント情報を設定します。',
        arcadeCode: 'アーケードコード',
        info: '情報',
        favoriteGame: 'お気に入りのゲーム',
        selectTheme: 'テーマを選択',
        updated: '更新!',
        codeSlot1: 'スロット1',
        codeSlot2: 'スロット2',
        codeSlot3: 'スロット3',
        seeRanking: 'ランキングを見る',
    },
    about: {
        aboutApp: 'アプリについて',
        trackerApp: 'Beatmania進捗トラッカーアプリ',
        keyFeatures: '主な機能:',
        progressTracking: '進捗・スコア・実績を追跡',
        arcadeHighScores: 'アーケードのハイスコアを追跡',
        translations: '英語と日本語で利用可能',
        gamesSupported: '対応ゲーム:',
        howToSubmit: '提出方法',
        setHomeScreen: 'ホーム画面に追加して進捗を追跡しましょう',
        github: 'Github',
        info: '情報',
        tipsTricks: 'ヒント＆コツ',
        questionsFeedback: 'ご質問・ご意見は',
        valueInput: '皆様のご意見を大切にし、継続的に改善しています。',
        broughtBy: '提供：',
        notAffiliated: '本アプリはKONAMI等の企業とは関係ありません。'
    },
    tips: {
        tipsForUsers: 'ユーザー向けヒント',
        findInfo: '使い方の情報',
        whatIsApp: 'このアプリとは？',
        notAGame: 'これはゲームではなく、ツールです。',
        bestWay: 'おすすめの使い方',
        singleSongs: 'シングル曲:',
        fullCourses: 'フルコース:',
        arcadeCodeRanking: 'アーケードコードとランキング',
        arcadeCodeInfo: 'アーケードコードは、アカウントをプレイするアーケードにリンクするために使います。',
        arcadeNotListed: 'アーケードがリストにありませんか？',
        arcadesOnRequest: 'リクエストで追加可能です。',
        tipScorePictures: 'TIP: スコア写真を撮る',
        scoreShownShort: '一部ゲームではスコア表示が短いので、写真を撮りましょう。',
        uploadEndSession: 'プレイ後にまとめてアップロードすると忘れません。'
    },
    import: {
        songsToJson: '曲をJSONへ',
        convert: '変換',
        copyJson: 'JSONをクリップボードへコピー',
        pressConvert: '変換ボタンを押してください',
        formatExcel: 'Excelからコピーした形式:'
    },
    admin: {
        adminPanel: '管理パネル',
        updateSongs: '曲を更新',
        updateGames: 'ゲームを更新',
        updateCourses: 'コースを更新',
        updateArcades: 'アーケードを更新',
        updateAchievements: '実績を更新',
        userList: 'ユーザーリスト',
        songToJson: '曲をJSONへ',
        updateStats: '統計を更新'
    },
    users: {
        usersList: 'ユーザーリスト',
        name: '名前',
        lastLogin: '最終ログイン'
    },
    arcade: {
        arcadeRankings: 'アーケードランキング',
        selectArcade: 'アーケード選択',
        selectGame: 'ゲーム選択',
        location: '場所:'
    },
    songRankings: {
        songLeaderboard: '曲リーダーボード',
        chooseSong: '曲を選択'
    },
    challenges: {
        challenges: 'チャレンジ',
        manage: 'チャレンジ管理',
        chooseChallenge: 'チャレンジを選択',
        chooseCourse: 'コースを選択',
        new: '新しいチャレンジ',
        title: 'チャレンジ名',
        instructions: '説明（任意）',
        state: '状態',
        status: { draft: '下書き', open: '受付中', closed: '終了' },
        saved: 'チャレンジを保存しました。',
        saving: '保存中…',
        loading: '読み込み中…',
        shareQr: 'QRを共有',
        downloadQr: 'QRをダウンロード',
        view: 'チャレンジを見る',
        courseLocked: 'スコア投稿後は店舗とコースを変更できません。',
        courseSongs: 'コースの曲',
        noChallenges: 'この店舗にはまだチャレンジがありません。',
        nickname: 'ランキング表示名',
        clearStatus: 'クリア状態',
        resultHint: 'リザルト画面に表示されたスコアとグレードを入力してください。',
        guestHint: 'アカウントは不要です。ランキング表示名は公開されます。',
        accountHint: '更新した記録はコースの進捗にも保存されます。ランキング表示名は公開されます。',
        submitScore: 'スコアを投稿',
        submitted: 'スコアを投稿しました。',
        progressSaved: 'コースの進捗に保存しました。自己ベストは維持されます。',
        keepScore: 'この記録をアカウントに保存して、次の自己ベストを目指しましょう。',
        loginSave: 'ログインして進捗に保存',
        registerSave: 'アカウントを作成して保存',
        saveToProgress: '進捗に保存',
        claimHint: 'ゲストの記録を保存するには、同じ端末とブラウザーを使用してください。',
        anotherAttempt: '別の記録を投稿',
        retry: 'この投稿を再試行',
        closedHint: 'このチャレンジは終了しました。ランキングは引き続き表示されます。',
        leaderboard: 'チャレンジランキング',
        bestAttempt: '各プレイヤーのベストスコアを表示します。',
        noScores: 'まだスコアがありません。最初の記録を投稿しましょう。',
        rank: '順位',
        arcadeChallenges: '店舗のチャレンジ',
        discord: {
            newResult: '🏆 チャレンジの新記録',
            player: 'プレイヤー',
            challenge: 'チャレンジ',
            score: 'スコア',
            grade: 'グレード',
            clear: 'クリア',
            failed: '失敗',
            cleared: 'クリア',
            fullCombo: 'フルコンボ',
            leaderboard: 'ランキングを見る'
        },
        errors: {
            invalidInput: '必須項目を確認してください。0以上の整数のスコアと、画面に表示されたグレードを入力してください。',
            requestFailed: '処理できませんでした。もう一度お試しください。',
            signInRequired: '進捗を保存するには再度ログインしてください。',
            adminRequired: 'このアカウントにはチャレンジ管理の権限がありません。',
            challengeNotFound: 'このチャレンジは利用できません。',
            courseNotFound: 'このコースは利用できません。',
            accountNotFound: 'アカウントが見つかりません。',
            invalidCourse: 'この店舗で利用できるゲームのコースを選択してください。',
            challengeLocked: '投稿があるチャレンジは店舗・コースの変更や下書きへの変更ができません。',
            challengeClosed: 'このチャレンジはスコアを受け付けていません。',
            invalidSubmission: '投稿を保存できませんでした。再読み込みしてお試しください。',
            cannotClaim: 'この記録はこのアカウントに保存できません。元のブラウザーとアカウントを使用してください。',
            tooManyAttempts: '1分待ってからもう一度お試しください。',
            methodNotAllowed: '処理できませんでした。もう一度お試しください。'
        }
    }
}
